import Item from "antd/lib/list/Item"
import React from "react"
import "./index.less"

const BottomAffix: React.FC = () => (
  <Item key="bottom-affix" className="rxd-auth-sidebar-bottom-affix" />
)

export default BottomAffix
